import { useLogger } from '#layers/base/composables/useLogger'
import { useUserStore } from '~/stores/user'

export default defineNuxtRouteMiddleware(async (to) => {
  const log = useLogger('auth-middleware')
  const localePath = useLocalePath()
  log.trace('Check route auth', { path: to.path, name: to.name })

  if (!to.name) { // undefined route
    log.warn('Undefined route: Tried to access undefined route', { path: to.path })
    if (!/^\/+[a-z]{2}(\/|$)/i.test(to.path)) {
      log.warn('Undefined route: Not a localized path, redirect to localized path', { path: to.path, localizedPath: localePath(to.path) })
      return navigateTo({ path: localePath(to.path) })
    }
    // /nl/welcome -> /welcome or /// -> / or /abc -> /abc or /c -> /
    const nonLocalized = to.path.replace(/^\/+(..\/|.{0,2}$)/, '/')
    if (to.path !== localePath(nonLocalized)) { // /nl/welcome <> /en/welcome or /abc <> /en/abc but /en/welcome === /en/welcome
      log.warn('Undefined route: Wrongly localized path', { oldPath: to.path, newPath: localePath(nonLocalized) })
      return navigateTo({ path: localePath(nonLocalized) })
    }
    // We should not end up here as long as the categories catching all routes!
    // So, if we end here it's a severe problem, or we cleaned the categories, therefore the warn-log.
    log.warn('Undefined route: No alternative route found redirect to login', { path: to.path })
    return navigateTo({
      path: localePath(`/login`),
      query: {
        from: localePath(`/welcome`),
        ...to.query,
      },
    })
  }

  const user = useUserStore()
  if (!user.isAuthenticated) {
    log.debug('User is not authenticated yet', { path: to.path, name: to.name } as any)
    await user.reloadAuth()
  }

  if (to.meta.isAuthPage && user.isAuthenticated) {
    log.debug('User is authenticated - redirect to the shop', { path: to.path })
    return navigateTo({
      path: to.query['from'] as string || localePath(`/welcome`),
      query: { ...to.query, from: undefined },
    })
  }

  if (to.meta.isPublicPage) {
    log.debug('Accessing public page', { path: to.path, meta: to.meta, name: to.name } as any)
    return // No authentication needed!
  }

  if (user.isAuthenticated) {
    log.debug(`Is authenticated`, { path: to.path, user: user.data?.email ?? '', name: to.name } as any)
    return // user is valid
  }

  log.debug('Not authenticated - redirect to login', { path: to.path, name: to.name } as any)
  return navigateTo({
    path: localePath('/login'),
    query: {
      from: to.path,
      ...to.query,
    },
  })
})
